import api from './api';
import { API_ENDPOINTS } from './endpoints';

export interface PageFilterParams {
    per_page?: number;
    page?: number;
}

export const pageService = {
    // Buscar todas as páginas do admin
    getAllPages: (params?: PageFilterParams) => 
        api.get(API_ENDPOINTS.PAGES.INDEX_ADMIN, { params }),

    // Buscar uma página específica pelo admin (id ou slug)
    getPageByIdOrSlug: (idOrSlug: string | number) => 
        api.get(API_ENDPOINTS.PAGES.SHOW_ADMIN(String(idOrSlug))),

    // Criar uma nova página
    createPage: (pageData: any) =>
        api.post(API_ENDPOINTS.PAGES.STORE, pageData),

    // Atualizar uma página
    updatePage: (idOrSlug: string | number, pageData: any) =>
        api.put(API_ENDPOINTS.PAGES.UPDATE(String(idOrSlug)), pageData),

    // Deletar uma página
    deletePage: (idOrSlug: string | number) =>
        api.delete(API_ENDPOINTS.PAGES.DESTROY(String(idOrSlug))),

    // Restaurar uma página excluída
    restorePage: (idOrSlug: string | number) =>
        api.post(API_ENDPOINTS.PAGES.RESTORE(String(idOrSlug))),
};
